import { render, staticRenderFns } from "./videoUploadWithTagType.vue?vue&type=template&id=c45bfd6c&scoped=true"
import script from "./videoUploadWithTagType.vue?vue&type=script&lang=js"
export * from "./videoUploadWithTagType.vue?vue&type=script&lang=js"
import style0 from "./videoUploadWithTagType.vue?vue&type=style&index=0&id=c45bfd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45bfd6c",
  null
  
)

export default component.exports